class UnsubscribeForm extends HTMLElement {
  constructor () {
    super()

    this.formElement = this.querySelector('form')
    this.emailField = this.querySelector('input[type="email"]')
    this.button = this.querySelector('button')
    this.successMessage = this.querySelector('#Unsubscribe-success')
    this.errorMessage = this.querySelector('#Unsubscribe-error')
    if (this.formElement) {
      this.formElement.addEventListener('submit', this.onFormSubmit.bind(this))
    }
  }

  async onFormSubmit (event) {
    event.preventDefault()
    if (!this.emailField) {
      return
    }

    try {
      const response = await fetch(`${window.BARREL.sbdApiUrl}/sfmc/unsubscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token: window.BARREL.sbdApiAccessToken
        },
        body: JSON.stringify({ email: this.emailField.value })
      })

      if (response.status >= 200 && response.status < 300) {
        this.showSuccess(true)
        console.log('success', response)
      } else {
        this.showError(true)
        console.error('unsubscribe error', response)
      }
    } catch (e) {
      console.log('unsubscribe message', e)
      this.showError(true)
    }
  }

  showSuccess (isSuccessful) {
    if (this.button) {
      this.button.classList.toggle('hidden', isSuccessful)
    }

    if (this.successMessage) {
      this.successMessage.toggleAttribute('hidden', !isSuccessful)
    }

    if (this.emailField) {
      if (isSuccessful) {
        this.emailField.value = ''
        this.emailField.removeAttribute('placeholder')
      }

      this.emailField.toggleAttribute('disabled', isSuccessful)
    }
  }

  showError (isError) {
    if (isError) {
      this.showSuccess(false)
    }

    if (this.button) {
      this.button.classList.toggle('hidden', !isError)
    }

    if (this.errorMessage) {
      this.errorMessage.toggleAttribute('hidden', !isError)
    }
  }
}

customElements.define('unsubscribe-form', UnsubscribeForm)
